import * as React from 'react';

import { observer } from 'mobx-react';
import styled from 'styled-components';
import { marketingPageSections as ms } from '~views/marketing-page/sections';
import { LOYALTY_POINT_BENEFIT } from '@estee/elc-service-view-names';
import { serviceName } from '~setup/packageInfo';
import { ServiceView } from '@estee/elc-service';
import { IPosition } from '~views/components/interfaces';
import { IPointBenefit } from '~views/marketing-page/point-benefit/IPointBenefit';

const TierBenefitSectionWrapper = styled.div`
    grid-area: ${ms.pointBenefit};
`;

export const TEST_ID_HERO_SECTION = 'loyalty-marketing-page-point-benefit-section';
export const TEST_ID_OFFER_DETAILS_POINTS = 'offer-details-points';

export interface IPointBenefitView extends IPosition {
    pointBenefit: IPointBenefit;
}

export const PointBenefit = observer(function TierBenefit(section: IPointBenefitView) {
    return (
        <TierBenefitSectionWrapper>
            <ServiceView name={LOYALTY_POINT_BENEFIT} serviceName={serviceName} config={section} />
        </TierBenefitSectionWrapper>
    );
});
